export class FormatadorHelper {
  private static readonly CPF_QUANTIDADE = 11;
  private static readonly CNPJ_QUANTIDADE = 14;

  static readonly MASCARA_CPF = '000.000.000-00';
  static readonly MASCARA_CNPJ = 'AA.AAA.AAA/AAAA-AA';
  static readonly EXEMPLO_CNPJ = 'LW.XK2.407/0001-83';

  static normalizarDocumento(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  }

  static ehCpf(value: string | null | undefined): boolean {
    const normalizado = this.normalizarDocumento(value);
    return normalizado.length === this.CPF_QUANTIDADE && /^\d+$/.test(normalizado);
  }

  static ehCnpj(value: string | null | undefined): boolean {
    const normalizado = this.normalizarDocumento(value);
    return normalizado.length === this.CNPJ_QUANTIDADE;
  }

  static formatarCpfCnpj(cpfCnpj: string): string {
    if (!cpfCnpj) return '';

    const normalizado = this.normalizarDocumento(cpfCnpj);

    if (this.ehCpf(normalizado)) {
      return normalizado.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    if (this.ehCnpj(normalizado)) {
      return normalizado.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
    }

    return cpfCnpj;
  }

  static aplicarMascaraDuranteInput(value: string, isCpf: boolean): string {
    if (isCpf) {
      const numeros = value.replace(/\D/g, '').slice(0, this.CPF_QUANTIDADE);
      return this.formatarCpfCnpj(numeros);
    }

    const normalizado = this.normalizarDocumento(value).slice(0, this.CNPJ_QUANTIDADE);
    return this.formatarCpfCnpj(normalizado);
  }

  static formatarTelefone(telefone: string): string {
    if (telefone !== null) {
      const telefoneLimpo = this.removeCaracteresNaoNumericos(telefone);
      return telefoneLimpo.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return '';
  }

  static removeCaracteresNaoNumericos(value: string): string {
    return value.replace(/\D/g, '');
  }
}
